"use strict";

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 8px 10px;\n  height: 50px;\n  transition: border-color 500ms ease-out;\n  outline: none;\n  ", ";\n  color: ", ";\n  border: 2px solid ", ";\n  border-radius: 5px;\n  box-sizing: border-box;\n\n  &::-webkit-input-placeholder {\n    color: ", ";\n  }\n\n  &::-moz-placeholder {\n    color: ", ";\n  }\n\n  &:-ms-input-placeholder {\n    color: ", ";\n  }\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  &[maxlength='1'] {\n    -moz-appearance: textfield;\n    display: block;\n    float: left;\n    padding: 0;\n    text-align: center;\n  }\n  @media (min-width: ", "px) {\n    width: 535px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.TextInput = styled_components_1.default.input(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.bodyStyle;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.copy;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.formBorder;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.formBorder;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.formBorder;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.formBorder;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.grid.breakpoints.md;
});